module.exports = __webpack_public_path__ + "static/media/close.fe31ff19.svg";